import {
   clsx
  ,styled
  ,Box
} from 'external/material'

import {isEmpty} from 'utils/text'
import {findGlobalIndex} from 'utils/assessment'
import {centerVertically} from 'utils/style'

import useTranslations from 'hooks/translations'
import useAssessment from 'hooks/assessment'
import useSession from 'hooks/session'

import questionHandlers from './question-handlers'

const QuestionContainer = styled(Box)(questionStyles)
 
export default function Question ({sections}) {

  const {translate} = useTranslations()
  const {questionId, sectionId} = useSession()
  const {assessment, assessmentLoaded, questionTypes = []} = useAssessment() 

  const count = sections.reduce((a, b) => a + b.questions.length, 0)

  const sectionIndex = sections.findIndex(s => s.id == sectionId)
  const section = sectionIndex >= 0 && sections[sectionIndex]

  const questionIndex = questionId && section ? section.questions.findIndex(q => q.id == questionId) : -1
  const question = questionIndex >= 0 && section.questions[questionIndex]

  const {html} = question && question.premise || {}

  const premiseHtml = isEmpty(html) ? false : html

  const type = questionTypes.find(t => t.id == question.type) || {}

  const title = translate(type.name)

  const globalIndex = findGlobalIndex(question.id, sections)
  const indexLabel = `${(translate('questions') || '').substring(0,1)}: ${globalIndex + 1}/${count}`

  const Handler = questionHandlers[type.name]

  const defaultPremiseLabel = `${type.name}-default-premise`
  const defaultPremise = translate(defaultPremiseLabel)
  const hasDefaultPremise = defaultPremiseLabel != defaultPremise

  return (
    <QuestionContainer key={question.id} className="root">
      <Box className="header">
        <Box className="title">{title}</Box>
        <Box className="index">{indexLabel}</Box>
      </Box>
      <Box className="content">
        {premiseHtml && <div className="premise" dangerouslySetInnerHTML={{__html: premiseHtml}} />}
        {!premiseHtml && hasDefaultPremise && <Box className="premise">{defaultPremise}</Box>}
        <Box className="question">
          {assessmentLoaded && Handler && <Handler question={question} />}
        </Box>
      </Box>
    </QuestionContainer>
  )
}

function questionStyles() {
  return {
    "&.root": {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      color: '#525b6c',
    },
    "& .header": {
      display: 'flex',
      fontSize: '13pt',
      padding: '10px 20px',
      borderBottom: 'solid 1px #d0d5d8',
    },
    "& .title": {
      flexGrow: 1,
      ...centerVertically
    },
    "& .index": {
      fontSize: '10pt',
      ...centerVertically
    },
    "& .content": {
      flexGrow: 1,
      overflowY: 'auto',
      padding: 30,
      display: 'flex',
      flexDirection: 'column',
    },
    "& .premise": {
      fontWeight: 'bold',
      fontSize: '12pt',
      marginBottom: 20
    },
    "& .question": {
      display: 'flex',
      flexGrow: 1
    }
  }
}
